import { useSections } from '../../context/site-content.context';
import { createElementId } from '../../helpers/content.helper';
import { GridVariant } from '../../models/component.model';
import { ImageContentDisplay } from '../images/ImageContentDisplay';
import { ContentHtml } from '../sections/ContentHtml';
import { GridVariantLinkDisplay } from './GridVariantLinkDisplay';

interface Props {
    before?: React.ReactNode;
    item: GridVariant;
}

export const GridVariantDisplay = ({
    item,
    before,
}: Props): React.ReactElement<any, any> | null => {
    const sections = useSections(item.id);
    const bootCols = 4;

    return (
        <div className="py-5 px-sm-5 px-4 grid-variant-display">
            {before}
            <div className="row justify-content-center">
                {sections.map(section => {
                    const id = createElementId(section.id);
                    return (
                        <div
                            id={id}
                            className={`col-xl-${bootCols} col-md-6 p-0 grid-content`}
                            key={id}
                        >
                            <div className="position-relative square grid-square">
                                {section.image && (
                                    <div
                                        className="position-absolute w-100 h-100"
                                        style={{ top: 0, left: 0 }}
                                    >
                                        <ImageContentDisplay image={section.image} />
                                    </div>
                                )}
                                <div className="position-absolute w-100 h-100 grid-content-curtain">
                                    <GridVariantLinkDisplay link={section.link}>
                                        <div className="d-flex flex-column justify-content-center h-100">
                                            <div className="overflow-y">
                                                <div className="px-4 m-4">
                                                    {section.header && (
                                                        <h2 className="display-6 mb-4 content-header">
                                                            {section.header}
                                                        </h2>
                                                    )}
                                                    {section.body && (
                                                        <ContentHtml source={section.body} />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </GridVariantLinkDisplay>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
